export const getLimitActions = (limitActions) => limitActions
    .split(',')
    .map(action => action.trim())
    .filter(Boolean);

export const getUserLimitAction = (actualLimits) => Object.values(actualLimits).find(limit => limit.action)?.action;

export const prepareLimitsForSave = (prev, next, availablePeriods) => ({
    limits: availablePeriods
        .filter(period => next[period] !== prev[period])
        .map((timePeriod) => ({
            amount: next[timePeriod] || '0',
            timePeriod
        })),
    action: next.action
});
